import { Box, styled } from "@mui/material";
import { useCheckoutUI } from "../../../CheckoutUIProvider";
import { CheckoutContext } from "../../../checkoutUIMachine";
import StoreRadio from "@/components/StoreComponents/StoreRadio";
import { updateShippingOption } from "@/api/rest/authenticated/Address";

import {
  MOBILE_SCREEN_SIZE,
  TABLET_SCREEN_SIZE,
} from "@/components/AppNavigation/constants";
import { formatMoney } from "@brandclub/common-ui";

const Container = styled(Box)({
  padding: "0px 0",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 16,

  ".shipping_group_list": {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  ".shipping_options": {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    maxWidth: 600,
    ".header": {
      fontSize: 16,
      fontWeight: 600,
    },
    ".single_option": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 0",
      borderBottom: "1px solid #f0f0f0",
      cursor: "pointer",
      "&:last-child": {
        borderBottom: "none",
      },
      ".option_content": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flex: 1,
      },
      ".option_details": {
        marginLeft: 12,
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      },
      ".option_title": {
        fontSize: 14,
        fontWeight: 500,
        [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
          fontSize: 14,
        },
        [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
          fontSize: 14,
        },
      },
      ".option_subtitle": {
        fontSize: 12,
        color: "#666",
        [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
          fontSize: 12,
        },
        [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
          fontSize: 12,
        },
      },
      ".option_price": {
        fontSize: 14,
        fontWeight: 600,
        color: "#000",
        "&.free": {
          color: "#28a745",
        },
      },
    },
  },
});

const DeliveryMethodSection = () => {
  const [state, send] = useCheckoutUI();
  const { checkoutIntent } = state.context as CheckoutContext;

  const shippingOptions = checkoutIntent?.shippingOptions || [];

  const handleSelectShippingOption = async (optionId: string) => {
    if (!checkoutIntent?.checkoutIntentId) return;

    try {
      const { checkoutIntent: updatedCheckoutIntent, status } =
        await updateShippingOption({
          checkoutIntentId: checkoutIntent.checkoutIntentId,
          shippingOptionId: optionId,
        });

      if (status === "success") {
        // Update checkout intent data in state machine
        send({
          type: "SET_CHECKOUT_INTENT",
          data: { checkoutIntent: updatedCheckoutIntent },
        });
      } else {
        console.error("Error updating shipping option");
      }
    } catch (error) {
      console.error("Error updating shipping option:", error);
    }
  };

  if (!shippingOptions.length) {
    return (
      <Container>
        <div className="shipping_group_list">
          <div style={{ padding: "16px 0", fontSize: "14px", color: "#666" }}>
            No delivery options available at this time.
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="shipping_group_list">
        {shippingOptions.map((option) => (
          <Box className="single_option" key={option.id}>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              width="100%"
            >
              <Box display="flex" flexDirection="row" alignItems="center">
                <StoreRadio
                  key={option.name}
                  checked={!!option.selected}
                  disableRipple
                  onClick={() => handleSelectShippingOption(option.id)}
                />
                <Box
                  marginLeft={1}
                  className="option_title"
                  sx={{
                    fontWight: option.selected ? 600 : 500,
                  }}
                >
                  {option.name} -{" "}
                  {option.amount === 0 ? "Free" : formatMoney(option.amount)}
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </div>
    </Container>
  );
};

export default DeliveryMethodSection;
